import { useEffect } from 'react'

/**
 * Closes a controlled filter surface when its options are no longer available.
 * Used when itinerary data changes while a desktop DropdownList, or the mobile
 * filters modal, may still be open.
 */
export function useCloseDropdownWhenUnavailable(
  hasOptions: boolean,
  setOpen: (open: boolean) => void,
): void {
  useEffect(() => {
    if (!hasOptions) {
      setOpen(false)
    }
  }, [hasOptions, setOpen])
}
